import { createSafeContext } from '@/util';

import type { VFrameTrackSliderContextValue } from './type';

export const VFrameTrackSliderContext =
  createSafeContext<VFrameTrackSliderContextValue>(
    null,
    'VFrameTrackSliderContext',
  );
